<template src="./vehicleinspactions.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
var moment = require("moment");
export default {
  components: {
    DocumentPopup,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  props: ["NewVehicle", "type", "ShowGenerateURL", "InspectionClasses", "inspectionVRM", "VehicleId"],
  data() {
    return {
      ImageEndpoint: Endpoints.Helper.Image + "/",
      VehicleInspections: [],
      CompanyInspections: [],
      SearchInspectionData: false,
      ShowSubmitVehicleInspectionModel: false,
      UniqueUrl:"",
      Mechanics:[],
      Mechanic :"",
      AttachMechanic : true,
      isMechanicAttached:false,
      ShowEmailLoader:false,
      VehicleInspectionNotes: "",
      ShowVehicleInspectionNotesModel: false,
      ShowVehicleInspectionNotesModelHeading: "Notes",
      VehicleInspections: [],
      CompanyInspections: [],
      SearchInspectionData: false,
      ShowSubmitVehicleInspectionModel: false,
      inspection_export_data:[],
      inspectionFromDate: "",
      inspectionToDate: "",
      expanded: []
    };
  },
  mounted() {
    setTimeout(() => {
      this.GetVehicleInspectionsList();
    }, 1500);
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
  },
  methods: {
    toggleReadMore(item, index) {
       this.$set(this.expanded, index, !this.expanded[index]);
       this.getDisplayText(item, index);
    },
    getDisplayText(item, index) {
      const fullHtml = item;
      if (this.expanded[index]) {
        return fullHtml;
      } else {
        const div = document.createElement("div");
        div.innerHTML = fullHtml;
        const text = div.innerText || div.textContent || "";
        if (text.length <= 80) return fullHtml;
        const trimmedText = text.substring(0, 80) + "...";
        return trimmedText;
      }
    },
    GetMechanics(){
      var obj = { token: localStorage.getItem("token") };
      obj.vehicle_id = this.VehicleId;
      Axios.post(Endpoints.VehicleInspections.GetMechanics, obj).then(
        (Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.Mechanics = Response.data.mechanics;
          }
        }
      );
    },
    sendInspectionURL(){
      this.ShowEmailLoader = true;
      var obj = { token: localStorage.getItem("token") };
      obj.unique_url = this.UniqueUrl;
      obj.mechanic_id = this.Mechanic;
      Axios.post(Endpoints.VehicleInspections.SendMail, obj).then(
        (Response) => {
          this.ShowEmailLoader = false;
            if (Response.data.success == true) {
              this.$swal.close();
              this.$swal
                .fire("Submit Inspection URL has been sent Successfully", "", "success")
                .then(() => {
                  this.ShowSubmitVehicleInspectionModel = false;
                  this.isMechanicAttached = false;
                  this.UniqueUrl = "";
                });
            } else {
              this.$swal
                .fire("Error:" + Response.data.message, "", "error")
                .then(() => {});
            }
        }
      );
    },
    generateUrlPopup(){
      this.Mechanic = "";
      this.GetMechanics();
      this.ShowSubmitVehicleInspectionModel = true;
      this.isMechanicAttached = false;
      this.UniqueUrl = "";
    },
    generateUrl(){
      var obj = { token: localStorage.getItem("token") };
      obj.vehicle_id = this.VehicleId;
      obj.mechanic_id = this.Mechanic;
      Axios.post(Endpoints.VehicleInspections.GenerateURL, obj).then(
        (Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            var uniqueUrl = Response.data.uniqueUrl;
            this.UniqueUrl = window.location.origin+'/create-vehicle-inspection/'+uniqueUrl;
            this.ShowSubmitVehicleInspectionModel = true;
            this.isMechanicAttached = true;
          }else{
            this.$swal
            .fire("Please select vehicle inspection mechanic", "", "error")
            .then(() => {});
          }
        }
      );
    },
    AddServiceDocument(type) {
      this.$parent.AddDocument(type);
    },
    LoadHistory(type) {
      this.$parent.LoadHistory();
    },
    EditServiceDocument(document) {
      this.$parent.EditDocument(document);
    },
    DeleteDocument(document_id) {
      this.$parent.DeleteVehicleDocument(document_id);
    },
    copy_text_input() {
      this.$refs.UniqueUrl.select();
      document.execCommand("copy");
      alert("copied");
    },
    GetVehicleInspectionsList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      obj.vehicleId = this.NewVehicle.id;
      obj.type = "VeihicleProfile";
      if (type == "search") {
        obj.fromDate = this.inspectionFromDate;
        obj.toDate = this.inspectionToDate;
      }
      obj.vehicle_class_name = this.NewVehicle.class;
      this.SearchInspectionData = true;
      Axios.post(Endpoints.VehicleInspections.InspectionsList, obj).then(
        (Response) => {
          this.SearchInspectionData = false;
          if (Response.data.success) {
            // ✅ sort_date add kar rahe hain
          this.VehicleInspections = Response.data.records.map((item) => {
            item.sort_date =
              item.item_type === "Custom PMI" &&
              item.fields &&
              item.fields.date &&
              item.fields.date.value
                ? item.fields.date.value
                : item.created_at;

            return item;
          });
            this.inspection_export_data = [];
            if (this.VehicleInspections.length > 0) {              
              this.VehicleInspections.forEach((element, index) => {
                this.expanded[index] = false;              
                var obj = {};
                if(element.item_type == 'Custom PMI'){
                  obj["Date"] = element.fields && element.fields.date && element.fields.date.value != ""
                    ? element.fields.date.value : element.created_at;
                }else{
                  obj["Date"] = element.created_at;
                }
                obj["Reg"] = element.vrm;
                obj["Defects Rectified"] = element.defects_rectified;
                obj["Defects Monitor"] = element.defects_monitor;
                obj["Notes"] = element.notes;
                this.inspection_export_data.push(obj);
              });
            }
          }
        }
      );
    },
    ViewDetailDocumentData(document){
    this.$parent.ViewDetailDocument(document);
  },
    DeleteVehicleInspection(inspection_id) {
      this.$swal({
        title: "Are you sure You want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: "Deleting...",
            text: "Please wait...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.VehicleInspections.InspectionDelete, {
            token: localStorage.getItem("token"),
            id: inspection_id,
          }).then((Response) => {
            if (Response.data.success === true) {
              this.$swal.close();
              this.GetVehicleInspectionsList();
              this.$swal
                .fire("Vehicle Inspection Deleted Successfully", "", "success")
                .then(() => {});
            } else {
              this.$swal
                .fire("Error:" + Response.data.message, "", "error")
                .then(() => {});
            }
          });
        }
      });
    },
    ShowVehicleInspectionNotes(VehicleInspection, type = "notes") {
      if (VehicleInspection.notes != null && VehicleInspection.notes != "") {
        this.ShowVehicleInspectionNotesModel = true;
        this.VehicleInspectionNotes = VehicleInspection.notes;
        this.ShowVehicleInspectionNotesModelHeading = "Notes";
      }
    },
  },
};
</script>
<style scoped >
.vehicle-inspection-table td{
  padding-left:0px !important;
}
.pre-formatted{
  margin-bottom: 5px;;
}
.view-more-btn{
  padding: 0;
  border: 0px;
  color: blue;
}
</style>
